// extracted by mini-css-extract-plugin
export default {"subtitlesHeader":"subtitlesHeader__ZKJJgP","appName":"appName__iAwwDQ"};